import styled from 'styled-components'

const SectionDescription = styled.p`
  font-size: 1.2em;
`

export default SectionDescription
